import { CustomRecurrenceViewState } from 'owa-calendar-compose-types';
import { orchestrator } from 'satcheljs';
import {
    initializeCustomRecurrenceForm,
    updateCustomRecurrenceFormRecurrenceType,
    updateCustomRecurrenceFormStartDate,
} from 'owa-calendar-compose-form-actions';

export default orchestrator(
    initializeCustomRecurrenceForm,
    (actionMessage: CustomRecurrenceViewState) => {
        const { recurrence, startDate } = actionMessage;
        updateCustomRecurrenceFormStartDate(startDate);
        updateCustomRecurrenceFormRecurrenceType(recurrence);
    }
);
